import { createColumnHelper } from '@tanstack/react-table';
import { lt } from '@mews/framework';
import { Typography } from '@optimus-web/core';
import { ServicesCell } from '../../../common/cells/ServicesCell';
import { ActionCell } from '../cells/ActionCell';
import { AttachmentLibraryTableRowData } from '../types';
import { getFileExtensionMimeType } from '../utils';

const columnHelper = createColumnHelper<AttachmentLibraryTableRowData>();

export const useAttachmentLibraryTableColumns = () => [
    columnHelper.accessor('name', {
        id: 'name',
        enableSorting: true,
        header: () => lt('ContractsAttachmentLibraryCustomFileName'),
        cell: ({ getValue }) => (
            <Typography textStyle="bodyMedium" as="div">
                {getValue()}
            </Typography>
        ),
        meta: {
            width: 450,
        },
    }),
    columnHelper.accessor('serviceIds', {
        id: 'serviceIds',
        enableSorting: true,
        header: () => lt('ContractsAttachmentLibraryApplicableServices'),
        cell: ({ getValue }) => <ServicesCell serviceIds={getValue()} />,
    }),
    columnHelper.accessor('type', {
        id: 'type',
        enableSorting: true,
        header: () => lt('ContractsFileTypeLabel'),
        cell: ({ getValue }) => (
            <Typography textStyle="bodyMedium" as="div">
                {getFileExtensionMimeType(getValue())}
            </Typography>
        ),
        meta: {
            width: 200,
        },
    }),
    columnHelper.accessor('size', {
        id: 'size',
        enableSorting: true,
        header: () => lt('ContractsSizeLabel'),
        cell: ({ getValue }) => (
            <Typography textStyle="bodyMedium" as="div">
                {getValue()}
            </Typography>
        ),
        meta: {
            width: 200,
        },
    }),
    columnHelper.display({
        id: 'actions',
        cell: ({ row }) => <ActionCell attachmentName={row.original.name} attachmentId={row.original.id} />,
        meta: {
            align: 'end',
            width: 60,
        },
    }),
];
